import axios from "axios";
import React, { useState } from "react";

const SetBoxName = (props) => {
  const [name, setName] = useState("");
  const token = localStorage.getItem("token");

  const updateName = async () => {
    await axios.put(
      `${process.env.REACT_APP_SERVER_URL}/subscription-name`,
      { name: name, boxAddress: props.address },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
  };

  return (
    <>
      <div
        className="relative z-50"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
      >
        <div className="fixed inset-0 bg-black backdrop-blur bg-opacity-20 transition-opacity"></div>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <div className="relative bg-gradient-to-bl from-[#212445] via-[#212445] to-[#462E52] rounded-lg shadow dark:bg-gray-700 py-2">
              <div className="bg-gradient-to-bl from-[#212445] via-[#212445] to-[#462E52] px-4 p-2">
                <div className="sm:flex sm:items-start">
                  <div className="p-2">
                    <h3 className="mb-2 text-xl font-medium text-white dark:text-white">
                      Set Box Name
                    </h3>

                    <div>
                      <label
                        htmlFor="email"
                        className="block mb-2 text-sm text-left font-medium text-white dark:text-white"
                      >
                        Enter Box Name
                      </label>
                      <input
                        type="text"
                        name="text"
                        id="text"
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                        placeholder="Enter Box Name"
                        required
                        onChange={(e) => setName(e.target.value)}
                      />
                    </div>

                    <button
                      type="button"
                      onClick={() => {
                        console.log(props.address);
                        updateName();
                        props.closeNamePopup();
                        props.updateNameInput(name);
                      }}
                      className="w-full mt-2 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                    >
                      Set Name 
                    </button>
                  </div>
                </div>
              </div>
              
              <button
                onClick={props.closeNamePopup}
                type="button"
                className=" mb-2 w-[90%] text-center rounded-lg bg-white px-5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 "
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SetBoxName;
